"use strict";
var classof = require("../internals/classof-raw");
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === "Array";
};
